import * as React from 'react';
import {connect} from 'react-redux';

import {change, FieldArray, formValueSelector} from 'redux-form';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';
import {FormField} from 'shells/form/form-field';
import {Divider} from 'shells/layout/divider';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';

import {TagSelect, AudienceSelect} from '../../../../core/form/fields';

import {FORM_NAME} from '../create-rules-constants';

const createRulesSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        tagIds: createRulesSelector(state, 'tagIds'),
        audienceIds: createRulesSelector(state, 'audienceIds'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onClearTags: () => {
            dispatch(change(FORM_NAME, 'tagIds', []));
        },
        onClearAudiences: () => {
            dispatch(change(FORM_NAME, 'audienceIds', []));
        },
    };
}

type StateProps = {
    tagIds: string[];
    audienceIds: string[];
};

type DispatchProps = {
    onClearTags: () => void;
    onClearAudiences: () => void;
};

type Props = StateProps & DispatchProps;

export function CreateRulesFormContactComponent(props: Props) {
    const [addTags, setAddTags] = React.useState<boolean>(
        Boolean(props.tagIds && props.tagIds.length)
    );
    const [addAudiences, setAddAudiences] = React.useState<boolean>(
        Boolean(props.audienceIds && props.audienceIds.length)
    );
    const {onClearTags, onClearAudiences} = props;

    React.useEffect(() => {
        if (!addTags) {
            onClearTags();
        }

        if (!addAudiences) {
            onClearAudiences();
        }
    }, [addTags, addAudiences, onClearTags, onClearAudiences]);

    return (
        <div>
            <div className='flex flex-dir-col'>
                <Body>Find and update existing people based on…</Body>
                <Body>
                    <strong>Email address</strong>
                </Body>
            </div>
            <Divider variant='line--horizontal' spacing={16} />
            <SpacerGroup mb={16}>
                <Body>When this person is created…</Body>
            </SpacerGroup>
            <FormField innerId='tagIds'>
                <ConditionalCheckboxInput
                    label='Add a tag'
                    isLarge={true}
                    checked={addTags}
                    onChange={(checked) => setAddTags(checked)}
                >
                    <FieldArray
                        name='tagIds'
                        component={TagSelect}
                        tagType='CONTACT'
                        shouldAnd={true}
                    />
                </ConditionalCheckboxInput>
            </FormField>
            <FormField innerId='audienceIds'>
                <ConditionalCheckboxInput
                    label='Add to an audience'
                    isLarge={true}
                    checked={addAudiences}
                    onChange={(checked) => setAddAudiences(checked)}
                >
                    <FieldArray name='audienceIds' component={AudienceSelect} shouldAnd={true} />
                </ConditionalCheckboxInput>
            </FormField>
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const CreateRulesFormContact = connector(CreateRulesFormContactComponent);
